import React, { useEffect, useState, useRef, useCallback  } from 'react';
import {Link, useParams, useNavigate } from 'react-router-dom';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import axios from 'axios';
import '../../css/private/inbox.css';
import SideBar from '../components/SideBar';

const InboxTemplate = ({}) => {
  const navigate = useNavigate();
  const { recipientId } = useParams();
  const [recipients, setRecipients] = useState([]);
  
    const [FullPageloading, setFullPageloading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [pageTwo, setPageTwo] = useState(0);
    const [hasMoreTwo, setHasMoreTwo] = useState(true);
    const [loadingMoreTwo, setLoadingMoreTwo] = useState(false);
    const peopleListRefTwo = useRef(null);
    const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [page, setPage] = useState(0);
  const loaderRef = useRef(null);
  const [client, setClient] = useState(null);
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState('');
  const [loadingOlder, setLoadingOlder] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const messagesEndRef = useRef(null);
  const chatBoxRef = useRef(null);
  const pageRef = useRef(0);
  const isPrependingRef = useRef(false);

  // Replace username with dynamic if needed
  const username = 'john_doe';

  // Reset inbox when recipient changes
  useEffect(() => {
    setMessages([]);
    setHasMore(true);
    pageRef.current = 0;
    if (client) {
      client.deactivate();
      setClient(null);
    }
  }, [recipientId]);

  // Fetch older messages with deduplication
  const fetchOldMessages = async () => {
    if (!hasMore || loadingOlder) return;
    setLoadingOlder(true);
    try {
      const pageToLoad = pageRef.current;
      const { data } = await axios.get(
        `https://localhost:8080/whatsapp-message/all?pageNumber=${pageToLoad}&pageSize=10&sortOrder=desc&recipientId=${recipientId}&username=${username}`
      );
      const newMessages = data.content.reverse();

      setHasMore(!data.lastPage);
      pageRef.current = data.pageNumber + 1;

      if (newMessages.length) {
        isPrependingRef.current = true;
        setMessages(prev => {
          const merged = [...newMessages, ...prev];
          const unique = merged.filter(
            (msg, idx, arr) => arr.findIndex(m => m.messageId === msg.messageId) === idx
          );
          return unique;
        });
      }
    } catch (err) {
      console.error('Fetch old messages error:', err);
    } finally {
      setLoadingOlder(false);
    }
  };

  // Set up WebSocket and load initial messages
  useEffect(() => {
    if (!recipientId) return;
    const socket = new SockJS('https://www.aadow.com:8080/ws');
    const stompClient = new Client({
      webSocketFactory: () => socket,
      onConnect: () => {
        stompClient.subscribe(`/topic/messages/${recipientId}`, ({ body }) => {
          const msg = JSON.parse(body);
          setMessages(prev => [...prev, msg]);
        });
      }
    });

    stompClient.activate();
    setClient(stompClient);

    (async () => {
      await fetchOldMessages();
      if (chatBoxRef.current) {
        chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
      }
    })();

    return () => stompClient.deactivate();
  }, [recipientId]);

  // Auto-scroll logic
  useEffect(() => {
    if (isPrependingRef.current) {
      isPrependingRef.current = false;
      return;
    }
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // Infinite scroll for older messages
  useEffect(() => {
    const onScroll = async () => {
      if (!hasMore || loadingOlder) return;
      const box = chatBoxRef.current;
      if (!box) return;
      if (box.scrollTop < 10) {
        const prevHeight = box.scrollHeight;
        await fetchOldMessages();
        const newHeight = box.scrollHeight;
        box.scrollTop = newHeight - prevHeight;
      }
    };

    const box = chatBoxRef.current;
    box?.addEventListener('scroll', onScroll);
    return () => box?.removeEventListener('scroll', onScroll);
  }, [hasMore, loadingOlder]);

  // Send message
  const sendMessage = async () => {
    if (!messageInput.trim()) return;

    const tempMessageId = `${username}-${Date.now()}`;
    const localMessage = {
      conversationId: username,
      messageBody: messageInput,
      sentBy: 'business',
      username,
      messageId: tempMessageId,
      senderId: 'whatsapp',
      recipientId,
      messageType: 'text',
      billable: false,
      messageStatus: 'SENT',
      pricingModel: 'CBP',
      category: 'UTILITY'
    };

    if (client && client.connected) {
      client.publish({ destination: '/app/chat/send', body: JSON.stringify(localMessage) });
    }

    const messageData = {
      messaging_product: 'whatsapp',
      to: recipientId,
      type: 'text',
      text: { body: messageInput }
    };

    try {
      const response = await axios.post(
        'https://graph.facebook.com/v19.0/575578602301147/messages',
        messageData,
        { headers: { Authorization: `Bearer EAAXOdC6dZBF8BO9ZAIkCz6zxZCf2QvkFliNS8FITHVMuXJOcQVjUiFCuANY60DzKQwR1cagEmHjxHhq3N6nly70AAZAoDHduRihL0EWgBSlfjrw1vDXLMp2jDjXZAG1pyLrLeN6c47L9jFKjdoU4wrUTQSZCBai0Xxv3NcOGOBB71XcpKROtjO4wZCiZA1vqwnbR2gZDZD`, 'Content-Type': 'application/json' } }
      );
      if (response.status !== 200) console.error('❌ Failed:', response);
    } catch (error) {
      console.error('WhatsApp API error:', error?.response?.data || error.message);
    }

    setMessageInput('');
  };

  const getRandomColor = (id) => {
        const colors = ["#bd0000", "#bd9100", "#2cbd00", "#00b7bd", "#003cbd", "#9d00bd", "#bd0068"];

        const index = Math.abs(hashCode(id)) % colors.length;
        return colors[index];
    };
    
    const hashCode = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    };

    const fetchImage = async () => {
       
    };

    const formatTimestamp = (timestamp) => {
        const now = new Date();
        const inputDate = new Date(timestamp);
    
        // Get today's start time (midnight)
        const today = new Date(now);
        today.setHours(0, 0, 0, 0);
    
        // Get yesterday's start time
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
    
        if (inputDate >= today) {
            // Today's date → Show time in "h:mm AM/PM" format
            return inputDate.toLocaleTimeString('en-IN', { hour: 'numeric', minute: 'numeric', hour12: true });
        } else if (inputDate >= yesterday) {
            // Yesterday's date → Show "Yesterday"
            return "Yesterday";
        } else {
            // Older dates → Show date in "dd MMM yyyy" format
            return inputDate.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
        }
    };

    const fetchConversations = useCallback(async (currentPage) => {
      if (loading || !hasMore) return;
      setLoading(true);
      try {
        const res = await axios.get(`https://localhost:8080/whatsapp-conversation/unique-recipients`, {
          params: {
            username,
            pageNumber: currentPage,
            pageSize: 10,
          },
        });

        const newConvos = res.data.content;

        setConversations((prev) => {
          const existingRecipientIds = new Set(prev.map((chat) => chat.recipientId));
          const uniqueNewConvos = newConvos.filter(
            (chat) => !existingRecipientIds.has(chat.recipientId)
          );
          return [...prev, ...uniqueNewConvos];
        });

        if (!res.data.lastPage) {
          setPage((prev) => prev + 1); // use function version
        }

        setHasMore(!res.data.lastPage);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
      setLoading(false);
    }, [hasMore, loading, username]);


      useEffect(() => {
        fetchConversations(0); // start with page 0
      }, []);

      // Setup IntersectionObserver
      useEffect(() => {
        
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore && !loading) {
            fetchConversations(page); // use current page
          }
        },
        { threshold: 1.0 }
      );

      const currentRef = loaderRef.current;
      if (currentRef) observer.observe(currentRef);

      return () => {
        if (currentRef) observer.unobserve(currentRef);
      };
    }, [fetchConversations, hasMore, loading, page]); // include `page` here


  
    

  return (
    <SideBar>
      {/* FULL-PAGE LOADING BACKDROP */}
      <div className="backdrop-container">
        { /* Controlled by FullPageloading */ }
        <div className="backdrop">
          <div className="spinner" />
        </div>
      </div>

      <div className="inbox-area">
        <div className="chat-container">
          
          {/* --- LEFT: PEOPLE / CONTACTS LIST --- */}
          <div className="people-area">
            <div className="header-area">
              <input
                type="text"
                className="search-box"
                placeholder="Search for Phone Number…"
                // value={searchTerm}
                // onChange={...}
                // onKeyDown={...}
                // onKeyUp={...}
                autoComplete="off"
              />
              <h3 className="title">Messages</h3>
            </div>
            
            <div className="people-list-area">
              {conversations.map((chat) => (
                <div
                  key={chat.id}
                  className="text-decoration-none"
                  onClick={() => navigate(`/whatsapp/inbox/${chat.recipientId}`)}
                >
                  <div className="chat-item">
                    <div
                      className="chat-avatar"
                      style={{ backgroundColor: getRandomColor(chat.recipientId) }}
                    >
                      <img
                        src="https://www.aadow.com/icons/profile.png"
                        alt="User Avatar"
                        className="chat-img"
                      />
                    </div>
                    <div className="chat-details">
                      <div className="chat-header">
                        <span className="chat-name">+{chat.recipientId}</span>
                        <span className="chat-time">
                          {new Date(chat.lastMessageAt).toLocaleString()}
                        </span>
                      </div>
                      <p className="chat-preview">
                        {chat.lastMessage || "No messages yet"}
                      </p>
                    </div>
                  </div>
                </div>
              ))}

              <div ref={loaderRef} style={{ height: "40px", marginTop: "10px" }}>
                {loading && <p>Loading more...</p>}
                {!hasMore && <p>No more conversations.</p>}
              </div>
            </div>
          </div>

          {/* --- RIGHT: CHAT WINDOW --- */}
          <div className="chat-area">
            {/*
              recipientId !== "all" && validPhone(recipientId) ?
              <> … chat header, body, footer … </>
              :
              <> … “No Inbox Selected” state … </>
            */}

            {/* CHAT HEADER */}
            <div className="chat-header">
              <div className="chat-avatar" style={{ backgroundColor: getRandomColor(recipientId) }}>

                <img 
                                            src={`https://www.aadow.com/icons/profile.png`} 
                                            alt="User Avatar"
                                            className='chat-img'
                                        />

              </div>
              <div className="chat-user-info">
                <span className="chat-user-name">+{recipientId}</span>
              </div>
              <i className="bi bi-three-dots-vertical chat-menu" />
            </div>

            {/* CHAT BODY */}
            <div className="chat-body" /* ref={chatBodyRef} */>
              {/*
                messages.length > 0 ? (
                  messages.reverse().map(msg ⇒
                    <div className={`chat-bubble ${msg.sentBy==="business" ? "me" : "other"}`}>
                      { msg.messageType==="image"
                          ? <img src={imageUrls[msg.messageBody]} className="chat-image"/>
                          : <p>{msg.messageBody}</p>
                      }
                      <h6 className="message-time">
                        {formatTimestamp(msg.createdAt)} · {msg.messageStatus}
                      </h6>
                    </div>
                  )
                ) : (
                  <div className="no-recipient">
                    <div className="error-content">
                      <i className="bi bi-chat-right error-icon" />
                      <h2 className="error-heading">No Messages Yet</h2>
                      <p className="error-subheading">
                        Start a conversation to see your messages here.
                      </p>
                    </div>
                  </div>
                )
              */}
                {messages != "" ? (
                <div ref={chatBoxRef} style={styles.chatBox}>
                    {loadingOlder && hasMore && <div style={styles.loader}>Loading...</div>}
                    {!hasMore && <div style={styles.noMore}>No earlier messages</div>}
                    {messages.map(msg => (
                    <div key={msg.messageId} style={{
                        ...styles.message,
                        alignSelf: msg.sentBy === 'business' ? 'flex-end' : 'flex-start',
                        backgroundColor: msg.sentBy === 'business' ? '#FFF' : '#FFF'
                    }}>

                        <div className={`chat-bubble ${msg.sentBy==="business" ? "me" : "other"}`}>
                        <p>{msg.messageBody}</p>
                        <h6 className="message-time">
                          {formatTimestamp(msg.createdAt)} · {msg.messageStatus}
                        </h6>
                        </div>

                    </div>
                    ))}
                    <div ref={messagesEndRef} />
                </div>
                ) : (
                  <div className="no-recipient">
                    <div className="error-content">
                      <i className="bi bi-chat-right error-icon" />
                      <h2 className="error-heading">No Messages Yet</h2>
                      <p className="error-subheading">
                        Start a conversation to see your messages here.
                      </p>
                    </div>
                  </div>
                )
                }
              </div>

            {/* CHAT FOOTER */}
            <div className="chat-footer">
              <input
                type="text"
                className="message-input"
                value={messageInput}
                onChange={e => setMessageInput(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && sendMessage()}
                placeholder="Type a message..."
              />
              <button
                className="send-button"
                onClick={sendMessage}
                // onClick={sendMessage}
                // disabled={isLoading}
              >
                { /* isLoading ? <div className="spinner" /> : <i className="bi bi-send" /> */ }
                Send
              </button>
            </div>
          </div>

        </div>
      </div>
    </SideBar>
  );
};


const styles = {
  container: { width: '100%', maxWidth: 600, margin: '0 auto', fontFamily: 'Arial, sans-serif' },
  recipientList: { display: 'flex', justifyContent: 'center', margin: '10px 0', gap: '8px' },
  header: { textAlign: 'center', margin: '10px 0' },
  chatBox: {
    display: 'flex',
    flexDirection: 'column',
    height: '85vh',
    overflowY: 'auto',
    padding: '0',
    borderRadius: '8px',
    paddingRight: '10px',
    backgroundColor: '#fff',
    marginBottom: '10px'
  },
  loader: { textAlign: 'center', padding: '8px', color: '#555' },
  noMore: { textAlign: 'center', padding: '8px', color: '#888', fontStyle: 'italic' },
  inputContainer: { display: 'flex' },
  input: { flex: 1, padding: '10px', borderRadius: '20px', border: '1px solid #ccc', marginRight: '8px' },
  button: { padding: '10px 16px', borderRadius: '20px', border: 'none', backgroundColor: '#4CAF50', color: 'white', cursor: 'pointer' }
};

export default InboxTemplate;
